import styled from 'styled-components';

const NewsletterContainer = styled.div.attrs(props => ({
  style: {
    marginBottom: `${props.marginBottom}px`,
    transform: `scale(${props.scale})`,
  },
}))`
  width: 100%;
  height: auto;
  transform-origin: top left;
`

export {
  NewsletterContainer
};